import { useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  LexicalCommand,
} from 'lexical';

export interface InsertEmojiPayload {
  emoji: string;
}

export const INSERT_EMOJI: LexicalCommand<InsertEmojiPayload> = createCommand();

export const EmojiPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand<InsertEmojiPayload>(
        INSERT_EMOJI,
        ({ emoji }) => {
          const selection = $getSelection();

          if (!$isRangeSelection(selection)) {
            return false;
          }

          selection.insertText(emoji);

          return true;
        },
        COMMAND_PRIORITY_EDITOR
      )
    );
  }, [editor]);

  return null;
};
